'use client';

import { Box, HStack, IconButton, Text } from '@chakra-ui/react';
import { FileText, X } from 'lucide-react';
import {
  formatDocumentSize,
  type DocumentAttachment,
} from '@/lib/research-assistant/document-attachments';

export function DocumentAttachmentChip({
  attachment,
  onRemove,
}: {
  attachment: DocumentAttachment;
  onRemove?: () => void;
}) {
  return (
    <HStack
      minW={0}
      maxW="260px"
      gap="2"
      px="2.5"
      py="2"
      borderWidth="1px"
      borderColor="ui.border.default"
      borderRadius="8px"
      bg="ui.surface.selected"
    >
      <Box color="ui.text.secondary" flexShrink={0}>
        <FileText size={18} aria-hidden="true" />
      </Box>
      <Box minW={0} flex="1">
        <Text fontSize="xs" fontWeight="600" color="ui.text.primary" truncate>
          {attachment.name}
        </Text>
        <Text fontSize="2xs" color="ui.text.tertiary">
          {formatDocumentSize(attachment.sizeBytes)}
        </Text>
      </Box>
      {onRemove ? (
        <IconButton
          aria-label={`Remove ${attachment.name}`}
          size="2xs"
          variant="ghost"
          color="ui.text.tertiary"
          flexShrink={0}
          onClick={onRemove}
        >
          <X size={12} />
        </IconButton>
      ) : null}
    </HStack>
  );
}
